import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * items: [{ name, path }] - path optional on last item (current page)
 */
export const Breadcrumbs = ({ items }) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className="text-sm"
      data-testid="breadcrumbs"
    >
      <ol className="flex flex-wrap items-center gap-1.5 text-slate-300">
        <li>
          <Link
            to="/"
            className="flex items-center gap-1 hover:text-gold transition-colors"
          >
            <Home className="w-3.5 h-3.5" />
            <span className="sr-only">Home</span>
          </Link>
        </li>
        {items.map((item, idx) => {
          const last = idx === items.length - 1;
          return (
            <li key={item.name} className="flex items-center gap-1.5">
              <ChevronRight className="w-3.5 h-3.5 text-slate-500" />
              {last || !item.path ? (
                <span className="text-gold font-medium" aria-current="page">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="hover:text-gold transition-colors"
                >
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
